import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
} from "@material-ui/core";
import { CloseIcon } from "@icarius-icons/index";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { getLocalizedString } from "@icarius-localization/strings";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { acceptRejectPerformanceSummaryAndResultsAction, previewDocumentsAction } from "@icarius-pages/performanceSummaryAndResults/actions";
import { formatNumberExactDecimals } from "@icarius-utils/format";
import { getYesNoArray } from "@icarius-utils/constants";
import useHandleForm from "./useHandleForm";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const AcceptRejectDialog = (props) => {

    const {
        open,
        data,
        processData,
        isSocietySignActive,
        handleClose,
    } = props;

    const [alreadyPreviewd, setAlreadyPreviewd] = useState(false);

    const dispatch = useDispatch();

    const handlePreview = () => {
        const dataToSend = {
            process: processData.process,
            evaluatedCode: data.evaluatedCode,
            toSign: true,
        };

        dispatch(previewDocumentsAction(dataToSend))
            .then((resp) => {
                if (resp.status === 200) {
                    setAlreadyPreviewd(true);
                }
            })
    }

    const handleSubmit = () => {
        if (isSocietySignActive && !alreadyPreviewd) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("youMustPreviewFileBeforeSigningIt"), severity: "warning", duration: 10000 }));
            return;
        }

        submit();
    }

    const create = (dataToSend) => {
        dispatch(acceptRejectPerformanceSummaryAndResultsAction({
            ...dataToSend,
            process: processData.process,
            evaluatedCode: data.evaluatedCode,
        }));
        handleClose();
    }

    const openValidationError = () => {
        dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
    }

    const {
        formData,
        setFormValue,
        submit,
    } = useHandleForm(data, create, openValidationError, isSocietySignActive);

    return (
        <Dialog
            open={open}
            TransitionComponent={DialogTransition}
            PaperComponent={PaperDraggable}
            maxWidth={"sm"}
            fullWidth={true}
        >
            <div className={"dialog-container"}>
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {getLocalizedString("acceptOrObject")}
                    <DialogTitleDivider />
                </DialogTitle>
                <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
                <DialogContent style={{ paddingTop: 0 }}>
                    <Typography className="whiteText" align="center" style={{ fontSize: 20, fontWeight: 600, paddingBottom: 10 }}>
                        {processData.processName}
                    </Typography>
                    <Grid container item xs={12} spacing={1}>
                        <Grid container item xs={12}>
                            <Typography className="whiteText">
                                {getLocalizedString("note2")}: <b>{data.note.toFixed(1)}</b>
                            </Typography>
                        </Grid>
                        <Grid container item xs={12}>
                            <Typography className="whiteText">
                                {getLocalizedString("noteName")}: <b>{data.noteName}</b>
                            </Typography>
                        </Grid>
                        <Grid container item xs={12}>
                            <Typography className="whiteText">
                                {getLocalizedString("ranking")}: <b>{formatNumberExactDecimals(data.ranking * 100, 2)}%</b>
                            </Typography>
                        </Grid>
                    </Grid>
                    {
                        // isSocietySignActive &&
                        <Typography className="whiteText" align="center" style={{ marginTop: 15 }}>
                            {getLocalizedString("acceptingTheEvaluationWillGenerateADocument")}
                        </Typography>
                    }
                    <Grid container item alignItems="center" xs={12} style={{ padding: '20px 0px' }}>
                        <FormControl style={{ width: "100%" }}>
                            <InputLabel required id={'label-approves'}>{getLocalizedString("approvePerformanceSummary")}</InputLabel>
                            <Select
                                value={formData.approves}
                                labelId={'label-approves'}
                                id={'select-approves'}
                                onChange={(e) => setFormValue(e.target.value, "approves")}
                                margin={"none"}
                            >
                                {
                                    getYesNoArray().map((item) => (
                                        <MenuItem
                                            className={"whiteText"}
                                            key={item.key}
                                            value={item.key}
                                        >
                                            {item.value}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    {
                        formData.approves === 'N' &&
                        <Grid container item xs={12}>
                            <TextFieldMultiline
                                required
                                fullWidth
                                label={getLocalizedString("enterYourCommentsHere")}
                                rows={5}
                                margin={"none"}
                                value={formData.comment}
                                inputProps={{ spellCheck: 'false' }}
                                onChange={(e) => setFormValue(e.target.value, "comment")}
                            />
                        </Grid>
                    }
                    {
                        formData.approves === 'Y' &&
                        <Grid container item alignItems="center" xs={12}>
                            <TextField
                                fullWidth
                                required
                                type="password"
                                label={getLocalizedString("pin")}
                                value={formData.password}
                                onChange={(e) => setFormValue(e.target.value, "password")}
                                autoComplete="new-password"
                                InputProps={{
                                    autoComplete: 'new-password',
                                }}
                            />
                        </Grid>
                    }
                </DialogContent>
                <DialogActions>
                    {
                        isSocietySignActive &&
                        <ButtonDialogAction onClick={handlePreview} isAccept text={getLocalizedString("previewDocuments")} />
                    }
                    <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
                    <ButtonDialogAction onClick={handleSubmit} isAccept text={isSocietySignActive ? getLocalizedString("acceptAndSign") : getLocalizedString("agree")} />
                </DialogActions>
            </div>
        </Dialog>
    );
}

export default AcceptRejectDialog;